import { render } from "./InterfaceRouterContainer.vue?vue&type=template&id=03184632&scoped=true"
import script from "./InterfaceRouterContainer.vue?vue&type=script&lang=js"
export * from "./InterfaceRouterContainer.vue?vue&type=script&lang=js"

import "./InterfaceRouterContainer.vue?vue&type=style&index=0&id=03184632&scoped=true&lang=scss"

import exportComponent from "/tmp/f3315f41-3418-4066-838e-b0c15008937b/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03184632"]])

export default __exports__